import { Delete } from "@mui/icons-material";
import { Card, IconButton, Box, Chip } from "@mui/material";
import { getEvidenceType } from "../../../common/EntitiesManagement";

export default function EvidenceTempleateItem({
  evidence,
  onDeleteEvidence,
  customValue,
}) {
  return (
    <Card
      variant="outlined"
      style={{ borderRadius: "5px" }}
      className="flex gap-2 w-full justify-between p-2 items-center"
    >
      <Box className="w-full flex gap-2 items-center">
        {onDeleteEvidence && (
          <IconButton onClick={onDeleteEvidence}>
            <Delete className="error_icon_color" />
          </IconButton>
        )}

        <label className="text-xs">{evidence.Name}</label>
      </Box>

      {(customValue ||
        evidence.Type) && (
          <Box sx={{ width: "100px" }}>
            <Chip
              sx={{
                "& .MuiChip-deleteIcon": {
                  color: "white",
                },
                "& .MuiChip-deleteIcon:hover": {
                  color: "white",
                },
              }}
              style={{
                margin: "2px",
                fontSize: "12px",
                fontWeight: 400,
                backgroundColor: "#10366E",
                color: "white",
                width: "100%",
              }}
              label={customValue ?? getEvidenceType(evidence.Type)}
            />
          </Box>
        )}
    </Card>
  );
}
